export interface BlogIndexEntry {
  slug: string;
  title: string;
  excerpt: string;
  publishedAt: string;
  /** Canonical URL on Substack (open in new tab). */
  url: string;
  coverImageUrl?: string;
  tags?: string[];
}

export interface BlogListResponse {
  articles: BlogIndexEntry[];
}

export interface ApiError {
  error: string;
}

export interface ContactRequest {
  name: string;
  email: string;
  message: string;
  /** Honeypot field — leave empty. */
  website?: string;
  phone?: string;
  /** Qué necesita construir. Opcional en /contacto. */
  intent?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  gclid?: string;
}

export interface ContactResponse {
  ok: true;
}

export class ApiClientError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'ApiClientError';
  }
}
